import { env } from "@/config/env";

/** Backend ImageField default when the user has not uploaded a photo. */
const DEFAULT_PROFILE_PIC_RE = /(?:^|\/)default_user(?:\.\w+)?(?:\?|#|$)/i;

/** Resolve relative media/profile URLs against the API origin. */
export function resolveMediaUrl(url?: string | null): string | null {
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;

  try {
    const origin =
      env.apiBaseUrl ||
      (typeof window !== "undefined" ? window.location.origin : "");
    if (!origin) return url;
    return new URL(url, origin).toString();
  } catch {
    return url;
  }
}

/** Like resolveMediaUrl, but treats the stock default avatar as "no photo". */
export function resolveProfilePicUrl(url?: string | null): string | null {
  const resolved = resolveMediaUrl(url);
  if (!resolved) return null;
  if (DEFAULT_PROFILE_PIC_RE.test(resolved)) return null;
  return resolved;
}

/** First letters of up to two name parts — e.g. "kiran bk" → "KB". */
export function initialsFromName(name: string, fallback = "?"): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return fallback;
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("") || fallback;
}
